import { DefaultError, useQuery } from '@tanstack/react-query';
import { apiClient } from 'utils';

export const useGetAppVersion = (enabled?: boolean) => {
  return useQuery<string, DefaultError>({
    queryKey: ['version'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Info/Version`,
      });

      //   console.log();

      return await response.text();
    },
    enabled: enabled,
    staleTime: 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};
